import axios from 'axios';

const BASE_URL_AI = process.env.REACT_APP_AI_URL || '/api/ai';

export const aiApi = axios.create({
  baseURL: BASE_URL_AI,
  headers: {
    'Content-Type': 'application/json',
  },
});

aiApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const sendAIChatMessage = async ({ question, currentRoute }) => {
  const response = await aiApi.post('/chat', {
    question,
    current_route: currentRoute,
  });
  return response.data;
};

export const fetchAIHealth = async () => {
  const response = await aiApi.get('/health');
  return response.data;
};
